import React, { useMemo } from 'react';
import { PreviewState } from "./ClientOnboarding.utils";
import { useResponsive } from "../contexts";
const CobConfigContext = /*#__PURE__*/React.createContext(undefined);
export function CobConfigProvider(props) {
  const {
    relationship,
    children,
    previewState
  } = props;
  const {
    isMobile
  } = useResponsive();
  const value = useMemo(() => ({
    relationship,
    isPreview: !!previewState,
    // We do not have a design for setup brand in mobile.
    isSetupBrand: previewState === PreviewState.SetupBrand && !isMobile
  }), [relationship, previewState, isMobile]);
  return /*#__PURE__*/React.createElement(CobConfigContext.Provider, {
    value: value
  }, children);
}
export function useCobConfig() {
  const context = React.useContext(CobConfigContext);
  if (!context) {
    throw new Error('useCobConfig must be used within a CobConfigProvider');
  }
  return context;
}